import { Injectable } from '@angular/core';
import { AemContactUsLabelData, ContactUsPayload, ContactUsState, FormState, UserData } from './definitions';
import { BehaviorSubject, Observable } from 'rxjs';
import { ContactUsFactory } from './contact-us.factory';
import { ApiResponse } from '../../definitions/api-response.interface';
import { ApiService } from '../../services/api/api.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';

@Injectable({
	providedIn: 'root'
})
export class ContactUsService
{
	private readonly state$: BehaviorSubject<ContactUsState> = new BehaviorSubject<ContactUsState>(ContactUsFactory.build());
	constructor(private readonly apiService: ApiService, private readonly toaster: ToastrService) { }
	contactFormData$: BehaviorSubject<UserData> = new BehaviorSubject<UserData>(ContactUsFactory.buildContactData());
	get state(): ContactUsState
	{
		return this.state$.value;
	}
	get stateChanged(): Observable<ContactUsState>
	{
		return this.state$.asObservable();
	}
	public updateState(value: ContactUsState): void
	{
		this.state$.next(value);
	}
	set updateContactForm(value: UserData)
	{
		this.contactFormData$.next(value);
	} 
	get contactFormData(): UserData
	{
		return this.contactFormData$.value;
	}
	contactUsTicket(payload : ContactUsPayload): void
	{
		this.state.loading = true;
		this.apiService.contactUsTicket(payload).subscribe({
			next: (res: ApiResponse) =>
			{
				const responseObj = <ApiResponse>res.data;
				this.state.response.data = responseObj;
				this.state.response.isInvalid = false;
				this.toaster.success(this.state.toasterSuccess.label);
				this.state.loading = false;

			},
			error: (error: HttpErrorResponse) =>
			{
				this.state.response.isInvalid = true;
				this.state.response.emailErrorMessage = error.message;
				this.toaster.error(error.error.message);
				this.state.loading = false;
			}
		});
	}

	public getContactUsState(): void
	{
		this.state.loading = true;
		this.apiService.getContactUsLabels().subscribe({
			next: (response: ApiResponse) =>
			{
				if (response)
				{
					const responseObj = <AemContactUsLabelData>response.data;
					this.mapContactUsState(responseObj);
					this.state.loading = false;
				}
			},
			error: () =>
			{
				this.state.loading = false;
			}
		});

	}

	public mapContactUsState(res: AemContactUsLabelData): void
	{
		this.state.pageHeading= res.pageHeading;
		this.state.sectionTopHeading = res.sectionTopHeading;

		for (let i = 0; i < this.state.sectionTopData.length; i++)
		{
			this.state.sectionTopData[i].label= res.sectionTopData[i].label;
			this.state.sectionTopData[i].placeholder= res.sectionTopData[i].placeholder;
			this.state.sectionTopData[i].errorMsg= res.sectionTopData[i].errorMsg;
			this.state.sectionTopData[i].isRequired= res.sectionTopData[i].isRequired;
		}

		this.state.sectionBottomHeading= res.sectionBottomHeading;

		this.state.sectionBottom= res.sectionBottom;
		for (const indx in this.state.sectionBottom.dropDownData)
		{
			this.state.sectionBottom.dropDownData[indx].isOpen =  false;
		}
		this.state.buttons.submit.label= res.buttons.submit;
		this.state.buttons.cancel.label= res.buttons.cancel;
		this.state.comments.label= res.comments.label;
		this.state.comments.placeholder= res.comments.placeholder;
		this.state.comments.errorMsg= res.comments.errorMsg;
		this.state.comments.isRequired= res.comments.isRequired;
		this.state.toasterSuccess= res.toasterSuccess;
		this.state.toasterFailure = res.toasterFailure;
		this.state.subreasonLabelData = res.subreasonLabelData;
		this.state.pageSubHeading = res.pageSubHeading;
	}
	getContactFormData(userEmail:string)
	{
		const payload = {
			email: userEmail
		};
		this.apiService.getContactForm(payload).subscribe({
			next: (res: ApiResponse) =>
			{
				const responseObj = <UserData>res.data;
				this.updateContactForm = responseObj;
				this.state.loading = false;
			},
			error: (error: HttpErrorResponse) =>
			{
				this.toaster.error(error.error.message);
				this.state.loading = false;
			},
			complete: () => 
			{
				this.handleValidation();
			}
		});
	}

	handleValidation(): void
	{
		const requiredFields = [
			FormState.firstName, FormState.lastName, FormState.email,  FormState.phoneNumber, FormState.companyName, FormState.country,  FormState.city, FormState.state 
		];

		for (const field of requiredFields) 
		{
			if (!this.contactFormData[field as keyof UserData]) 
			{
				this.toaster.error( 'Unable to fetch your details, please enter manually?' );
				return;
			}
		}
	}
}
